import React from "react";
import {Avatar, Chip, Tooltip} from "@mui/material";
import {
    CheckCircleOutline as CheckIcon,
    EditOutlined as EditIcon,
    ErrorOutline as ErrorIcon,
    InfoOutlined as InfoIcon,
    LockOutlined as LockIcon
} from "@mui/icons-material";
import {STATUS_SISTEMA, catalogoDeManifesto, revisaoCurta} from "../sistemaPagina";
import {ALERTAS, TIPOS_FUNCIONALIDADE} from "../catalogoRegras";

const COR_PADRAO = '#475569';

// Sigla sobre a cor da marca, como no checkout e na escolha de assinatura.
export const SistemaLogo = ({sistema, tamanho = 40}) => (
    <Avatar
        variant="rounded"
        aria-hidden
        sx={{
            width: tamanho,
            height: tamanho,
            bgcolor: sistema?.cor || COR_PADRAO,
            color: '#fff',
            fontSize: tamanho * 0.38,
            fontWeight: 700,
            flexShrink: 0,
        }}
    >
        {sistema?.sigla || (sistema?.nome || '?').slice(0, 2).toUpperCase()}
    </Avatar>
);

export const StatusChip = ({status}) => {
    const info = STATUS_SISTEMA[status] || {rotulo: status || 'Sem status', cor: 'default'};
    return <Chip size="small" label={info.rotulo} color={info.cor} variant={status === 'VENDA' ? 'filled' : 'outlined'} />;
};

// De onde vem o catálogo (BBF-103). Sem `fonte_catalogo` na resposta, a API ainda não diz, e o chip não aparece.
export const FonteChip = ({sistema}) => {
    const fonte = sistema?.fonte_catalogo;
    if (!fonte) return null;
    if (!catalogoDeManifesto(sistema)) return <Chip size="small" variant="outlined" icon={<EditIcon fontSize="small" />} label="Cadastro manual" />;
    const revisao = revisaoCurta(fonte.revisao);
    return (
        <Tooltip title={`Catálogo do manifesto ${fonte.origem}: somente leitura aqui.`}>
            <Chip size="small" color="primary" variant="outlined" icon={<LockIcon fontSize="small" />} label={revisao ? `Manifesto · ${revisao}` : 'Manifesto'} />
        </Tooltip>
    );
};

const ICONE_DA_COR = {
    error: <ErrorIcon fontSize="small" />,
    warning: <EditIcon fontSize="small" />,
    info: <InfoIcon fontSize="small" />,
    success: <CheckIcon fontSize="small" />,
    default: <InfoIcon fontSize="small" />,
};

export const iconeDaCor = (cor) => ICONE_DA_COR[cor] || ICONE_DA_COR.default;

export const CompletudeChip = ({completude}) => (
    <Chip size="small" variant="outlined" color={completude.cor} icon={iconeDaCor(completude.cor)} label={completude.texto} />
);

export const TipoChip = ({tipo}) => (
    tipo
        ? <Chip label={TIPOS_FUNCIONALIDADE.find((item) => item.value === tipo)?.label || tipo} size="small" color={tipo === 'LEITURA' ? 'info' : 'warning'} variant="outlined" />
        : <Chip label="Sem tipo" size="small" variant="outlined" />
);

export const AlertaChip = ({alerta, metodo}) => {
    const info = ALERTAS[alerta];
    if (!info) return null;
    return (
        <Tooltip title={info.explicacao}>
            <Chip label={info.rotulo(metodo)} size="small" color="warning" variant="outlined" icon={<InfoIcon fontSize="small" />} />
        </Tooltip>
    );
};
